import { useQuery } from "@tanstack/react-query";
import type { SalesforceSyncErrorType } from "@/types/salesforce-sync-status";

interface SyncStatusResponse {
  hasCriticalError: boolean;
  errorType: SalesforceSyncErrorType | null;
  lastSyncAt: string | null;
}

/**
 * Hook to poll Salesforce sync status every 5 minutes
 * Returns sync status including critical errors, error types, and last sync time
 */
export function useSalesforceSyncStatus() {
  return useQuery<SyncStatusResponse>({
    queryKey: ["salesforce-sync-status"],
    queryFn: async () => {
      const res = await fetch("/api/salesforce/sync-status");
      if (!res.ok) {
        throw new Error("Failed to fetch sync status");
      }
      return res.json();
    },
    refetchInterval: 5 * 60 * 1000, // 5 minutes
    staleTime: 4 * 60 * 1000, // Consider data stale after 4 minutes
    retry: 3,
  });
}
